import { render, staticRenderFns } from "./DataPoints.vue?vue&type=template&id=41dc69a2&scoped=true"
import script from "./DataPoints.vue?vue&type=script&lang=js"
export * from "./DataPoints.vue?vue&type=script&lang=js"
import style0 from "./DataPoints.vue?vue&type=style&index=0&id=41dc69a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc69a2",
  null
  
)

export default component.exports